import React from 'react';

import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 読み物の段落（thoughts-ai の Paragraph 相当）。明朝体・行高2.0・冒頭字下げ。
 * params: text（joined, Markdown 可）、indent（任意, "false" で字下げなし）
 */
export const ProseText: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const text = (node.params.text as string) ?? '';
  const noIndent = (node.params.indent as string) === 'false';

  return (
    <Typography
      component="div"
      sx={{
        fontSize: 14,
        fontFamily: SERIF_FONT,
        color: '#1A1A1A',
        lineHeight: 2.0,
        textIndent: noIndent ? 0 : '1em',
        mb: 1.8,
        // 中身の Markdown も明朝・同じサイズ・色に揃える（太字などの装飾は残す）
        '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
          margin: 0,
          fontFamily: 'inherit',
          fontSize: 'inherit',
          lineHeight: 'inherit',
          color: 'inherit',
          background: 'transparent',
        },
      }}
    >
      {renderInline(text)}
    </Typography>
  );
};

export default ProseText;
